module.exports = __webpack_public_path__ + "static/path-has-correct-domain-a4bc569f9d94bfa11a269425e454223d.png";